export const patientValidationErrors: { [key: string]: string } = {
  INVALID_NHS_NUMBER: "NHS number is not valid",
  NHS_NUMBER_EXISTS: "Patient with this NHS number already registered in hospital",
  PATIENT_HOSPITAL_NUMBER_EXISTS: "Patient with this number already registered in hospital",
  FUTURE_DATE: "Date of birth can't be in the future",
  INVALID_POSTCODE: "Please enter a valid postcode",
  INVALID_PHONE_NUMBER: "Please enter a valid phone number",
  EMAIL_INVALID: "E-mail is not valid",
  SERVICE_CONSENT_REQUIRED: "Consent to Liberty Service is required for newly created patients",
  PRIVACY_POLICY_CONSENT_REQUIRED: "Consent to Privacy Policy is required for newly created patients",
};
